var o={loyaltyPoint:"LogoCircleAgodacashFillIcon"};export{o as default};
